import { ReactNode } from 'react';
import { Translate } from 'next-translate';
import { notification } from '@arkestro/arkestro-design-system';

import { ErrorState, ID } from 'types';

import { countErrors } from './countErrors';

const key = 'errors';

// Error messages will not dismiss themselves until all errors have been resolved
// or the user clicks the ‘X’ icon.
const duration = 0;

// The message will display from the bottom right corner of the screen.
const placement = 'bottomRight' as const;

const defaults = { duration, key, placement };

interface ToggleErrorNotificationParams {
  count?: number;
  description: ReactNode;
  lotsErrors?: Record<ID, ErrorState<ID>>;
  t: Translate;
}

export const toggleErrorNotification = ({ count: knownCount, description, lotsErrors, t }: ToggleErrorNotificationParams): void => {
  const count = knownCount ?? countErrors(lotsErrors ?? {});

  if (count) {
    const message = t('bid_request.line_items.validation.message', { count });

    notification.error({ ...defaults, description, message });
  } else {
    notification.destroy(key);
  }
};
